module.exports = __webpack_public_path__ + "img/IMG_20191126_235547.85696428.jpg";